// let CancelToken;
// let source;

// const Config = require('~/config/default.env').default;

export default {
  namespaced: true,
  state: {
    categories: [],
    countryList: [],
    brandList: [],
    brands_filter: '',
    queryString: {
      sort: '',
      limit: 20,
      skip: 0,
      brands: '',
      category: '',
      origins: '',
      rating: '',
      available_for: '',
      tags: '',
    },
  },
  mutations: {
    SET_BRAND_NAME(state, data) {
      state.brandList = data;
    },
    SET_BRAND_ORIGIN(state, data) {
      state.countryList = data;
    },
    SET_LIST_BRAND_FILTER(state, data) {
      state.brands_filter = data;
    },
    SET_QUERY_STRING(state, { name, value }) {
      state.queryString[name] = value;
    },
    SET_CATEGORIES(state, data) {
      state.categories = data;
    },
  },
  actions: {
    serialize({ commit, state }, query) {
      if (typeof query === 'object') {
        for (const prop in query) {
          if (query.hasOwnProperty(prop)) {
            if (prop === 'page') {
              commit('SET_QUERY_STRING', {
                name: 'skip',
                value: state.queryString.limit * (query[prop] - 1),
              });
            } else {
              commit('SET_QUERY_STRING', { name: prop, value: query[prop] });
            }
          }
        }

        if (!query.page && state.queryString.skip) {
          commit('SET_QUERY_STRING', { name: 'skip', value: 0 });
        }
      }
    },
    async getCategoriesChildren({ state, dispatch, commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            this._vm.$MS_CATALOG_API_URL.get(`/v3/categories/children`, {
              params: {
                filter: {
                  ...(keyword && {
                    my_soco_sql_id: keyword,
                  }),
                  depth: 3,
                },
                fields:
                  'name,my_soco_sql_id,my_sociolla_sql_id,link_rewrite,parents,slug,banner_for_sociolla,logo,is_featured',
                skip: 0,
                limit: 10,
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        const results = data.data.children;
        commit('SET_CATEGORIES', results);
      });
    },
    async getBrandsOrigin({ state, dispatch, commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          if (keyword) {
            resolve(this._vm.$MS_SOCO_PUBLIC_API_URL.get(`/product/categories/${keyword}/brands`));
          } else {
            resolve(
              this._vm.$MS_CATALOG_API_URL.get('/v3/brands/letters', {
                params: {
                  filter: {
                    group_by_country: true,
                    cache: true,
                  },
                  limit: 300,
                  sort: 'origins.country',
                  fields: 'name,logo,slug,origins.country,origins.flag',
                },
              })
            );
          }
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        const origins = (data && data.data) || {};
        if (keyword) {
          commit('SET_BRAND_ORIGIN', origins);
        } else {
          const results = Object.values(origins).reduce((result, origin) => {
            if (origin && origin.length) {
              result = [...result, ...origin];
            }
            return result;
          }, []);
          commit('SET_BRAND_ORIGIN', results);
        }
      });
    },
    async getBrandsLetter({ state, dispatch, commit }, keyword) {
      return new Promise((resolve, reject) => {
        try {
          if (keyword) {
            resolve(this._vm.$MS_SOCO_PUBLIC_API_URL.get(`/product/categories/${keyword}/brands`));
          } else {
            resolve(
              this._vm.$MS_CATALOG_API_URL.get('/v3/brands/letters', {
                params: {
                  limit: 300,
                  sort: 'name',
                  fields: 'name,logo,slug',
                },
              })
            );
          }
        } catch (error) {
          reject(error);
        }
      }).then(({ data }) => {
        const name = (data && data.data) || {};
        if (keyword) {
          commit('SET_BRAND_NAME', name);
        } else {
          const results = Object.values(name).reduce((result, name) => {
            if (name && name.length) {
              result = [...result, ...name];
            }
            return result;
          }, []);
          commit('SET_BRAND_NAME', results);
        }
      });
    },
  },
};
